import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithubAlt } from "@fortawesome/free-brands-svg-icons"
import {
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import "./styles/card.css"


const Card = ({
  name,
  desc,
  content,
  imageSrc,
  imageAlt,
  tags,
  link,
  githubLink,
  video,
  badge,
  spotlight,
  onClick,
}) => {
  const [showDetails, setShowDetails] = useState(false)

  return (
    <>
      <div className="pj-other-wrap">
        <div
          className={`pj-other${
            spotlight
              ? " ring-1 ring-[#eeeeff]/30 shadow-[0_0_30px_-6px_rgba(238,238,255,0.28)]"
              : ""
          }`}
        >
          <div className="pj-other-body">

            <div className="flex justify-between">

              <div className="flex justify-between items-center w-full">
                <h2 className="pj-other-title">{name}</h2>
                {badge && (
                  <span className="pj-badge mb-2">
                    {badge}
                  </span>
                )}
              </div>
              {(link || githubLink) && (
                <div className="flex gap-3 justify-end" style={{ padding: "10px 18px 0" }}>
                  {link && (
                    <a href={link} target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon
                        className="h-5 w-5 text-[#eeeeff] bg-[#0e0e16] border border-[#1e1e2e] p-2 inline-block rounded-md transition ease-in hover:bg-[#eeeeff] hover:text-[#0e0e16] hover:border-[#0e0e16]"
                        icon={faArrowUpRightFromSquare}
                      />
                    </a>
                  )}
                  {githubLink && (
                    <a href={githubLink} target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon
                        className="h-5 w-5 text-[#eeeeff] bg-[#0e0e16] border border-[#1e1e2e] p-2 inline-block rounded-md transition ease-in hover:bg-[#eeeeff] hover:text-[#0e0e16] hover:border-[#0e0e16]"
                        icon={faGithubAlt}
                      />
                    </a>
                  )}
                </div>
              )}
            </div>

             <div className="card-details-inner pj-other-desc">
              {desc}
            </div>

            {content && (
              <>
                <button
                  className="card-toggle-btn"
                  onClick={() => setShowDetails((v) => !v)}
                  aria-expanded={showDetails}
                >
                  <i className={`card-arrow ${showDetails ? "open" : ""}`}>▾</i>
                  {showDetails ? "hide details" : "more details"}
                </button>

                <div className={`card-details ${showDetails ? "open" : ""}`}>
                  <div className="card-details-inner pj-other-desc">
                    {imageSrc && (
                      <img
                        src={imageSrc}
                        alt={imageAlt || name}
                        className="card-details-image"
                        onClick={onClick}
                      />
                    )}
                    {content}
                  </div>
                </div>
              </>
            )}

            <div className="pj-other-tags" style={{ marginTop: "14px" }}>
              {tags.map((tag) => (
                <span key={tag} className="pj-hero-tag">{tag}</span>
              ))}
            </div>


          </div>
        </div>
      </div>
    </>
  )
}


const FeaturedCard = ({
  name,
  description,
  meta,
  content,
  tags,
  link,
  linkLabel,
  githubLink,
  noLinkLabel,
  imageSrc,
  imageAlt,
  imageHeight,
  imageFit,
  badge,
}) => {
  const [showDetails, setShowDetails] = useState(false)

  return (
    <div className="pj-hero-wrap">
      <div className="pj-hero">
        <div className="">
          {imageSrc && (
            <img
              src={imageSrc}
              alt={imageAlt || name}
              style={imageHeight ? { height: imageHeight, width: "100%", objectFit: imageFit } : undefined}
            />
          )
          }
        </div>

        <div className="pj-hero-body">
          <div className="flex gap-4">
            <h2 className="pj-hero-title">{name}</h2>
            <div className="pj-eyebrow">
              {/* <span className="pj-badge">{badge || "✦ Featured project ✦"}</span> */}
            </div>
          </div>

          {meta && meta.length > 0 && (
            <div className="pj-hero-meta">
              {meta.map((item) => (
                <span key={item} className="pj-meta-item">{item}</span>
              ))}
            </div>
          )}

          <p className="pj-hero-desc">{description}</p>

          {content && (
            <>
              <button
                className="card-toggle-btn"
                style={{ width: "100%", paddingTop: "20px" }}
                onClick={() => setShowDetails((v) => !v)}
                aria-expanded={showDetails}
              >
                <i className={`card-arrow ${showDetails ? "open" : ""}`}>▾</i>
                {showDetails ? "hide details" : "more details"}
              </button>

              <div className={`card-details ${showDetails ? "open" : ""}`}>
                <div
                  className="card-details-inner pj-other-desc"
                  style={{ maxWidth: "750px", paddingBottom: "18px" }}
                >
                  {content}
                </div>
              </div>
            </>
          )}

          <div className="pj-hero-tags">
            {tags.map((tag) => (
              <span key={tag} className="pj-hero-tag">{tag}</span>
            ))}
          </div>

          <div className="pj-hero-actions">
            {link && (
              <a href={link} target="_blank" rel="noopener noreferrer" className="pj-btn-primary">
                {linkLabel || "Visit site"}
              </a>
            )}
            {githubLink && (
              <a href={githubLink} target="_blank" rel="noopener noreferrer" className="pj-btn-secondary">
                GitHub →
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}


const TimelineCard = ({
  logo,
  title,
  details,
  date,
  content
}) => {

  return (
    <div className="overflow-hidden rounded-lg bg-[#0a0a10] mb-8 border border-[#1e1e2e]">
      <div className="px-4 py-5 sm:px-6 flex">
        <img
          src={logo}
          alt="logo"
          className="max-h-16"
        />
        <div className="ml-5">
          <div className="flex flex-col text-left">
            <h2 className="text-md font-semibold text-[#eeeeff]">{title}</h2>
            <div className="text-sm text-[#eeeeff] font-roboto font-light">{details}</div>
            <div className="text-sm text-[#eeeeff] font-roboto font-light">{date}</div>
          </div>
        </div>
      </div>
      {content? <div className=" text-sm py-5 sm:p-6 text-left font-roboto font-light text-[#8992b2] bg-[#14141E]">{content}</div> : <></>}
    </div>
  )
}


export { Card, FeaturedCard, TimelineCard }